import { Codec } from './types'

export class StringCodec implements Codec<string> {
    encode = (s: string): string => s

    decode = (s: string): string => s
}
export class DateCodec implements Codec<Date> {
    encode = (s: Date): string => s.toISOString()

    decode = (s: string): Date => new Date(s)
}
export class NumberCodec implements Codec<number> {
    encode = (n: number): string => n.toString(10)

    decode = (s: string): number => {
        const res = s.includes('.') ? parseFloat(s) : parseInt(s)

        if (isNaN(res)) throw new Error('Cannot parse number value ' + s)

        return res
    }
}

export class BooleanCodec implements Codec<boolean> {
    encode = (b: boolean): string => b.toString()

    decode = (s: string): boolean => {
        if (s === 'true') return true
        else if (s === 'false') return false

        throw new Error('Cannot parse boolean value ' + s)
    }
}
